import { SnackBar } from '@common/Snackbars/Snackbar';

export const onInfoShow = (message: string) => SnackBar('info', message);
